import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spotlight-event-stamp',
  templateUrl: './spotlight-event-stamp.component.html',
  styleUrls: ['./spotlight-event-stamp.component.css']
})
export class SpotlightEventStampComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
